/* src/app/signin/signin.component.scss */
main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  height: 100%;
  background-image: url("./media/background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
main > app-signin-card {
  flex-basis: 100%;
  max-width: 500px;
  margin-bottom: 10rem;
}
/*# sourceMappingURL=signin.component.css.map */
